export enum DocumentAPIPath {
  DownloadApplication = '/document/download-application',
  DownloadCOI = '/document/download-certificate-of-insurance',
  DownloadDocument = '/document/download-document',
  DownloadIndicationApp = '/document/download-indication-application',
  DownloadQuote = '/document/download-quote-proposal',
  DownloadQuoteApp = '/document/download-quote-proposal-application',
  DirectBill = '/document/download-direct-bill-notice',
  DownloadSLForm = '/document/download-sl-form',
  DownloadSLFormByFormName='/document/download-slform-byformname'
}
